module.exports = __webpack_public_path__ + "static/img/TheKitchen1979Program_1_FPO.4dde02f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/TheKitchen1979Program_1_FPO.jpg
// module id = 4WRZ
// module chunks = 0